module.exports = __webpack_public_path__ + "toolkit-static/img/2ing.35f4a3c2.png";